<template>
    <div class="investment-banner">
        <div class="container h-100 d-flex flex-row justify-content-between">
            <a href="https://www.crowdcube.com/early-access/krispyhouse" target="_blank">
                <img src="/img/crowdcube-logo.webp" width="150" class="investment-banner__logo over-desktop-only" alt="Crowdcube logo"/>
            </a>
            <div class="investment-banner__description d-flex flex-column align-items-start justify-content-center">
                <p>Invest as little as £10 into krispyhouse</p>
                <img src="/img/crowdcube-underline.svg" class="investment-banner__underline" alt="underline" />
            </div>
            <a
                href="https://www.crowdcube.com/early-access/krispyhouse"
                class="investment-banner__link d-flex justify-content-center align-items-center"
                target="_blank">
                Register Interest
            </a>
        </div>
    </div>
</template>

<script>
export default {};
</script>
